import gql from 'graphql-tag';

import { courseFragment } from '~/shared/graphql-queries/courses/index';

export default gql`
  mutation updateByIdCourseMutation(
    $_id: MongoID!
    $record: UpdateByIdCourseInput!
  ) {
    updateByIdCourseMutation(_id: $_id, record: $record) {
      recordId
      record {
        ...CourseFragment
      }
      message
      title
    }
  }
  ${courseFragment}
`;
